export enum smartSearchType {
  textInput = "textInput",
  singleSelect = "singleSelect",
  multipleSelect = "multipleSelect",
  yearMonthSelct = "yearMonthSelct",
  dateSelct = "dateSelct",
  dateRangeSelct = "dateRangeSelct",
  dateTimeRangeSelct = "dateTimeRangeSelct",
}
